import config from '../../../config';
import models from '../../../model';
import { LogicContext } from '../types';
import { checkIfFetchStrikeGold } from '../../../utils/strikeGold/checkIfFetchStrikeGold';

export const fetchStrikeGold = (context: LogicContext) => async () => {
  const { controllersData } = context;
  if (!checkIfFetchStrikeGold(controllersData?.categories))
    return { ...context.strikeGoldData };

  const { status, data } = await models.fetchStrikeGoldData({
    market_country: config.viewer_country,
  });

  return {
    status,
    strikeGold: data,
  };
};
